// Portions Copyright 2019 Jimb Esser (https://github.com/Jimbly/)
// Released under MIT License: https://opensource.org/licenses/MIT

exports.resume = exports.tick = function () {
  // nothing
};

export function loading() {
  return 0;
}